(function () {
	document.addEventListener("DOMContentLoaded", () => {
		const header = document.querySelector(".site-header");
		if (!header) {
			return;
		}

		let isScrolled = false;

		const onScroll = () => {
			// Histéresis (umbrales distintos para activar/desactivar): evita que el
			// cambio de fondo/logo entre en bucle justo en el punto de scroll donde
			// se activa.
			if (!isScrolled && window.scrollY > 40) {
				isScrolled = true;
			} else if (isScrolled && window.scrollY < 20) {
				isScrolled = false;
			}
			header.classList.toggle("is-scrolled", isScrolled);
		};

		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });

		const toggle = header.querySelector(".menu-toggle");
		const nav = header.querySelector(".site-nav");
		if (!toggle || !nav) {
			return;
		}

		const closeMenu = () => {
			nav.classList.remove("is-open");
			toggle.setAttribute("aria-expanded", "false");
		};

		toggle.addEventListener("click", () => {
			const isOpen = nav.classList.toggle("is-open");
			toggle.setAttribute("aria-expanded", String(isOpen));
		});

		nav.querySelectorAll(".site-nav__link").forEach((link) => {
			link.addEventListener("click", closeMenu);
		});

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				closeMenu();
			}
		});
	});
})();
